import * as React from 'react'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/style.css'

import { cn } from '@/lib/utils'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({
  className,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      className={cn(
        '[--rdp-accent-color:hsl(var(--primary))]',
        '[--rdp-accent-background-color:hsl(var(--primary))]',
        '[--rdp-day-height:36px]',
        '[--rdp-day-width:36px]',
        '[--rdp-day_button-height:34px]',
        '[--rdp-day_button-width:34px]',
        '[--rdp-day_button-border-radius:8px]',
        '[--rdp-selected-border:none]',
        '[--rdp-today-color:hsl(var(--primary))]',
        'p-3',
        className
      )}
      {...props}
    />
  )
}
Calendar.displayName = 'Calendar'

export { Calendar }
